export default __webpack_public_path__ + "static/media/Group9415.c58548a4.svg";